import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { cn } from '../lib/utils';
import { Terminal } from 'lucide-react';

const curlExample = `curl -X POST https://ocr.tyosolution.com/api/v1/ocr/extract \\
  -H "Authorization: Bearer YOUR_TOKEN" \\
  -F "file=@invoice.pdf" \\
  -F "fields=vendor_name,invoice_number,total_amount,due_date,line_items"`;

const jsonResponse = `{
  "fields": {
    "vendor_name":     { "value": "PT Tyo Solution Indonesia", "confidence": 1.0 },
    "invoice_number":  { "value": "INV-2026-0001",            "confidence": 1.0 },
    "total_amount":    { "value": "8,214,000",                "confidence": 1.0 },
    "due_date":        { "value": "2026-05-25",               "confidence": 1.0 },
    "line_items":      { "value": [...],                      "confidence": 0.7 }
  },
  "credits_used": 3
}`;

function CodeBlock({ label, code, lang = 'bash' }) {
  return (
    <div className='rounded-2xl overflow-hidden border border-border shadow-card'>
      <div className='flex items-center gap-2 px-4 py-2.5 bg-muted border-b border-border'>
        <div className='flex gap-1.5'>
          <span className='w-3 h-3 rounded-full bg-[hsl(0_84%_70%)]' />
          <span className='w-3 h-3 rounded-full bg-credit' />
          <span className='w-3 h-3 rounded-full bg-success' />
        </div>
        <span className='text-xs text-muted-foreground font-mono ml-2'>{label}</span>
      </div>
      <pre className='bg-card p-5 overflow-x-auto text-xs font-mono leading-relaxed text-foreground whitespace-pre'>
        {code}
      </pre>
    </div>
  );
}

export default function TestimonialsSection() {
  const [ref, visible] = useScrollAnimation();

  return (
    <section ref={ref} className={cn('py-24 bg-surface reveal', visible && 'revealed')}>
      <div className='max-w-5xl mx-auto px-4 sm:px-6 lg:px-8'>
        {/* Header */}
        <div className='text-center max-w-2xl mx-auto mb-16'>
          <span className='inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-primary/8 text-primary border border-primary/20 mb-4'>
            <Terminal className='w-3.5 h-3.5' />
            Quick Start
          </span>
          <h2 className='font-heading font-bold text-4xl lg:text-5xl text-foreground mb-4'>
            One request, structured data
          </h2>
          <p className='text-muted-foreground text-lg'>
            Pass the field names you want. Get back values and confidence scores.
          </p>
        </div>

        {/* Code blocks */}
        <div className='space-y-6'>
          <div className={cn('reveal reveal-delay-1', visible && 'revealed')}>
            <CodeBlock label='request.sh — POST to /extract' code={curlExample} />
          </div>
          <div className={cn('reveal reveal-delay-2', visible && 'revealed')}>
            <CodeBlock label='response.json — structured output' code={jsonResponse} />
          </div>
        </div>

        <p className='text-center text-sm text-muted-foreground mt-8'>
          Full API reference at{' '}
          <a
            href='https://ocr.tyosolution.com/docs'
            target='_blank'
            rel='noopener noreferrer'
            className='text-primary hover:underline'
          >
            ocr.tyosolution.com/docs
          </a>
        </p>
      </div>
    </section>
  );
}


